import TableEntidadesItem from "./TableEntidadesItem";

const { __ } = wp.i18n;

function TableEntidades({ entidades }) {
  return (
    <div className="table-entidades">
      <div className="table-header">
        <div className="table-cell has-text-gray-400-color table-cell__title">{ __('Nombre Entidad' ,'bizum-website') }</div>
        <div className="table-cell on-nonmobile has-text-gray-400-color">{ __('Email' ,'bizum-website') }</div>
        <div className="table-cell on-nonmobile has-text-gray-400-color">{ __('Teléfono' ,'bizum-website') }</div>
        <div className="table-cell on-nonmobile has-text-gray-400-color table-cell__external-link"></div>
      </div>
      {entidades.map(item => {
        return (
          <TableEntidadesItem key={item.id} entidad={item} />
        )
      })}
    </div>
  )
}

export default TableEntidades